<div class="header" xmlns="http://www.w3.org/1999/html">
  <div class="logo logo-dark">
    <a href="">
      <img src="assets/images/logo/HausmeisterAppLogo-LightInline.svg" alt="Logo">
      <img class="logo-fold" src="assets/images/favicon.png" alt="Logo">
    </a>
  </div>
  <div class="nav-wrap">
    <ul class="nav-left">
      <li class="desktop-toggle">
        <a (click)="toggleFold()">
          <i nz-icon [nzType]="isFolded? 'menu-unfold':'menu-fold'" nzTheme="outline"></i>
        </a>
      </li>
      <li class="mobile-toggle">
        <a (click)="toggleExpand()">
          <i nz-icon [nzType]="isExpand? 'menu-fold': 'menu-unfold'" nzTheme="outline"></i>
        </a>
      </li>

      <nz-divider [nzType]="'vertical'"></nz-divider>

      <li nz-tooltip nzTooltipPlacement="bottom" [nzTooltipTitle]="'Aufgaben' | translate">
        <a routerLink="/tasks" class="m-h-5">
          <i nz-icon nzType="schedule" nzTheme="outline"></i>
        </a>
      </li>
      <li nz-tooltip nzTooltipPlacement="bottom" [nzTooltipTitle]="'Tickets' | translate">
        <a routerLink="/tickets" class="m-h-5">
          <i nz-icon nzType="inbox" nzTheme="outline"></i>
        </a>
      </li>
      @if (authservice.can('duedates.view') && (ips.overdueCount > 0 || ips.inGraceCount > 0 || assetDueDates.overdueCount > 0 || assetDueDates.todayCount > 0)) {
        <li nz-tooltip nzTooltipPlacement="bottom" [nzTooltipTitle]="overdueTooltip">
          <a routerLink="/dashboard/overdue" class="m-h-5">
            <nz-badge [nzCount]="ips.overdueCount + ips.inGraceCount + assetDueDates.overdueCount + assetDueDates.todayCount"
                      [nzStyle]="{ backgroundColor: ips.overdueCount > 0 || assetDueDates.overdueCount > 0 ? '#ff4d4f' : '#fa8c16' }">
              <i nz-icon nzType="warning" nzTheme="outline" [style.color]="ips.overdueCount > 0 || assetDueDates.overdueCount > 0 ? '#ff4d4f' : '#fa8c16'"></i>
            </nz-badge>
          </a>
        </li>
        <ng-template #overdueTooltip>
          @if (ips.overdueCount > 0) { <div>{{ '{{count}} überfällig' | translate: {count: ips.overdueCount} }}</div> }
          @if (ips.inGraceCount > 0) { <div>{{ '{{count}} in Toleranz' | translate: {count: ips.inGraceCount} }}</div> }
          @if (assetDueDates.overdueCount > 0) { <div>{{ '{{count}} Sachanlagen-Termine überfällig' | translate: {count: assetDueDates.overdueCount} }}</div> }
          @if (assetDueDates.todayCount > 0) { <div>{{ '{{count}} Sachanlagen-Termine heute fällig' | translate: {count: assetDueDates.todayCount} }}</div> }
        </ng-template>
      }
    </ul>


    <div style="width: 65%">
      <app-global-search-v2></app-global-search-v2>
    </div>

    <ul class="nav-right pull-right">

      @if (user.company?.billing?.timetrackingmodule) {
        <li>
          <a nz-dropdown nzTrigger="click" (click)="timeService.load()" style="min-width: 130px;"
             [ngClass]="{'time-btn' : timeService.getLastAction() === 'KOMMEN' || timeService.getLastAction() === 'PAUSE' || timeService.getLastAction() === 'GEHEN'}"
             [nzDropdownMenu]="popTimetracking" [nzPlacement]="'bottomRight'">
            @if (timeService.getLastAction() === 'GEHEN' || !timeService.getLastAction()) {
              <i class="m-r-10" nz-icon nzType="field-time" nzTheme="outline"></i> <small
              >{{ timeService.dutyTime | async }}</small>
            }
            @if (timeService.getLastAction() === 'KOMMEN') {
              @if (timeService.getLastAction() === 'KOMMEN') {
                <i class="m-r-10" nz-icon
                   [nzType]="timeService.getLastType()?.icon_web || 'tool'"
                   nzTheme="outline" style="font-size: medium;"></i>
              }
              <strong><small class="color-orange">{{ timeService.dutyTime | async }}</small></strong>
            }
            @if (timeService.getLastAction() === 'PAUSE') {
              @if (timeService.getLastAction() === 'PAUSE') {
                <i class="m-r-10" nz-icon nzType="coffee"
                   nzTheme="outline" style="font-size: medium;"></i>
              }
              <strong><small class="color-blue"
              >{{ timeService.breakTime | async }}</small></strong>
            }
          </a>
          <nz-dropdown-menu #popTimetracking="nzDropdownMenu" nz-col>
            <div nz-menu class="p-10 pop-notification">
              <app-time-tracking #appTimeTracking></app-time-tracking>
            </div>
          </nz-dropdown-menu>
        </li>
      }

      <li>
        <app-global-news-center></app-global-news-center>
      </li>

      <li>
        <a nz-dropdown [nzDropdownMenu]="support" [nzPlacement]="'bottomRight'">
          <i nz-icon nzType="question-circle" nzTheme="outline"></i>
        </a>
        <nz-dropdown-menu #support="nzDropdownMenu">
          <div nz-menu class="pop-notification">
            <div class="p-10">
              <div>
                <h5 style="float: left">{{ 'Kontakt' | translate }}</h5>
                <div class="pull-right">
                  <nz-tag nzColor="yellow">{{ 'Kunden-ID' | translate }}: <strong class="m-l-10">{{ authservice.currentUserValue?.company?.code }}</strong></nz-tag>
                </div>
              </div>

              <button nz-button nzBlock nzType="primary" (click)="toggleChat()"><i nz-icon nzType="comment"
                                                                                   nzTheme="outline"></i> {{ 'Hilfe & Kontakt' | translate }}
              </button>
              <a nz-button nzBlock class="m-t-5" nzType="default" href="https://www.youtube.com/channel/UCQCtmG4jrg_340XyzxglHxQ"
                 target="_blank"><i nz-icon nzType="youtube" nzTheme="outline"></i> {{ 'Einführungsvideos' | translate }}
              </a>
              <a nz-button nzBlock class="m-t-5" nzType="default" href="https://hilfe.hausmeisterapp.com"
                 target="_blank"><i nz-icon nzType="read" nzTheme="outline"></i> {{ 'Wiki / Helpcenter / Anleitungen' | translate }}
              </a>

              <a nz-button nzBlock class="m-t-5" nzType="default" href="https://shop.hausmeisterapp.com"
                 target="_blank"><i nz-icon nzType="shopping-cart" nzTheme="outline"></i> {{ 'NFC-Tags bestellen' | translate }}
              </a>
              <!--<ul class="ant-list">
                <li><i nz-icon nzType="mail" nzTheme="outline"></i> <a href="mailto:service@hausmeisterapp.com"
                                                                       target="_blank">service&#64;hausmeisterapp.com</a>
                </li>
                <li><i nz-icon nzType="phone" nzTheme="outline"></i> <a href="tel:00498131316464" target="_blank">+49
                  (0)8131
                  316464</a>
                </li>
              </ul>-->
            </div>

          </div>
        </nz-dropdown-menu>

      </li>

      <li [title]="'Neu' | translate">
        <a class="m-h-5" nz-dropdown [nzDropdownMenu]="shortcutsMenu" [nzPlacement]="'bottomRight'">
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i>
        </a>
        <nz-dropdown-menu #shortcutsMenu="nzDropdownMenu">
          <ul nz-menu>
            <li *appCan="'tickets.create'" (click)="ticketService.newTicketModal()" nz-menu-item>
              <a><i nz-icon nzType="inbox" nzTheme="outline"></i> {{ 'Ticket erstellen' | translate }}</a>
            </li>
            <li *appCan="['tasks.create', 'tasks.own']" [routerLink]="'./tasks/new'" nz-menu-item>
              <a><i nz-icon nzType="schedule" nzTheme="outline"></i> {{ 'Aufgabe erstellen' | translate }}</a>
            </li>
          </ul>
        </nz-dropdown-menu>
      </li>
      <li>
        <app-language-switcher></app-language-switcher>
      </li>
      <li>
        <app-notification-dropdown [showListLink]="true" [openActionUrl]="true"></app-notification-dropdown>
      </li>

      <li>
  <span class="p-h-10 pointer" nz-dropdown [nzDropdownMenu]="profile" [nzTrigger]="'click'"
        [nzPlacement]="'bottomRight'">
    <nz-avatar
      [nzSrc]="user.avatarPath ? backendURL + '/' + user.avatarPath : ''"
      [nzIcon]="user.avatarPath ? backendURL + '/' + user.avatarPath : 'user'"
      style="vertical-align: middle;"
    ></nz-avatar>
  </span>
        <nz-dropdown-menu #profile="nzDropdownMenu">
          <ul nz-menu class="p-b-15 p-t-20">
            <li class="p-h-20 p-b-15 m-b-10 border-bottom">
              <div class="d-flex m-r-50">
                <nz-avatar
                  [nzSrc]="user.avatarPath ? backendURL + '/' + user.avatarPath : ''"
                  [nzIcon]="user.avatarPath ? backendURL + '/' + user.avatarPath : 'user'"
                  nzSize="large"
                  style="vertical-align: middle;"
                ></nz-avatar>
                <div class="m-l-10">
                  <p class="m-b-0 text-dark font-weight-semibold">{{ user.name }}</p>
                  <p class="m-b-0 opacity-07">{{ user.email }}</p>
                </div>
              </div>
            </li>
            <li nz-menu-item>
              <a [routerLink]="'/account'" class="p-v-5 d-flex align-items-center justify-content-between">
                <div>
                  <i class="opacity-04 font-size-16" nz-icon nzType="lock" nzTheme="outline"></i>
                  <span class="m-l-10">{{ 'Account Einstellungen' | translate }}</span>
                </div>
                <i class="font-size-10" nz-icon nzType="right" nzTheme="outline"></i>
              </a>
            </li>
            <li nz-menu-item (click)="authservice.logout()">
              <a class="p-v-5 d-flex align-items-center justify-content-between">
                <div>
                  <i class="opacity-04 font-size-16" nz-icon nzType="logout" nzTheme="outline"></i>
                  <span class="m-l-10">{{ 'Logout' | translate }}</span>
                </div>
                <i class="font-size-10" nz-icon nzType="right" nzTheme="outline"></i>
              </a>
            </li>
          </ul>
        </nz-dropdown-menu>
      </li>
      @if (false) {
        <li>
          <a (click)="quickViewToggle()">
            <i nz-icon nzType="appstore" nzTheme="outline"></i>
          </a>
          <nz-drawer [nzWidth]="280" nzTitle="Quick View" [nzClosable]="false" [nzVisible]="quickViewVisible"
                     nzPlacement="right" (nzOnClose)="quickViewToggle()">
            <app-quick-view></app-quick-view>
          </nz-drawer>
        </li>
      }
    </ul>


  </div>
</div>


<!-- nur wenn tatsächlich etwas offen ist (bezahlte, noch markierte Rechnungen zählen nicht) -->
@if (overdueInvoicesTotal > 0) {
  <div class="overdue-invoices-spacer"></div>
  <div class="overdue-invoices">
    <i nz-icon nzType="exclamation-circle" nzTheme="fill" class="overdue-invoices-icon"></i>
    <div class="overdue-invoices-text">
      @if (invoiceDues.onlyFeesDue(user?.overdueInvoices)) {
        <!-- Rechnungen bezahlt, offen sind nur noch Mahngebühren -->
        <strong>{{ 'Vielen Dank, Ihre Rechnungen sind bezahlt – offen sind nur noch Mahngebühren.' | translate }}</strong>
        {{ 'Bitte überweisen Sie diese noch, um eine Sperrung des Accounts zu verhindern.' | translate }}
      } @else {
        <strong>{{ 'Ihr Kundenkonto weist unbezahlte Rechnungen auf.' | translate }}</strong>
        {{ 'Bitte begleichen Sie alle offenen Forderungen umgehend, um eine Sperrung des Accounts zu verhindern.' | translate }}
      }
      {{ 'Fragen?' | translate }} <a (click)="toggleChat()">{{ 'Zum Support-Chat' | translate }}</a>
      @if (overdueInvoicesTotal > 0) {
        <br>
        @if (invoiceDues.onlyFeesDue(user.overdueInvoices)) {
          <strong>{{ 'Noch offen: {{amount}} Mahngebühren.' | translate: {amount: overdueFeesTotal | currency: 'EUR'} }}</strong>
        } @else {
          <strong>{{ 'Offener Gesamtbetrag: {{amount}}' | translate: {amount: overdueInvoicesTotal | currency: 'EUR'} }}</strong>
          @if (overdueFeesTotal > 0) {
            {{ '(inkl. {{amount}} Mahngebühren)' | translate: {amount: overdueFeesTotal | currency: 'EUR'} }}
          }.
        }
      }
    </div>
    <!-- zur Rechnungsübersicht in "Mein Unternehmen" (nur Administratoren sehen die Rechnungen) -->
    @if (user?.isAdmin) {
      <a nz-button nzDanger class="overdue-invoices-button" routerLink="/company" [queryParams]="{tab: 'invoices'}">
        <i nz-icon nzType="file-text"></i> {{ 'Zu den Rechnungen' | translate }}
      </a>
    }
  </div>
}

